import React from 'react';

function CheckSVG(_ref) {
  var isIndeterminate = _ref.isIndeterminate;
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "-3 0 22 18",
    "aria-hidden": "true",
    className: "size-e-0.875 [stroke-dasharray:22] [stroke-dashoffset:44px]",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2.5"
  }, isIndeterminate ? /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 7.5,
    width: 15,
    height: 3
  }) : /*#__PURE__*/React.createElement("polyline", {
    points: "1 9 7 14 15 4"
  }));
}

export { CheckSVG };
//# sourceMappingURL=check-svg.esm.js.map
